import React, { useState, useEffect, useContext } from "react";
import "./tabsSection.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import FooterRatesTabs from "../../atoms/footer-tabs-rates/footer-tabs-rates";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import SupportGroupFooter from "../support-g-footer/supportGroupFooter";
import LayoutContext from "../../../contexts/layoutContext";
import GlobalContext from "../../../contexts/globalContext";

import Button from "../../atoms/button/button";
import { navigate } from "gatsby";

let showSlider = [1.3];
const TabsSection = (props: ReferenciaContenido) => {
  const { location } = props;
  const datas = Object.values(location ? location : { key: 0 });
  const [activeItem, setActiveItem] = useState(
    datas.length > 1 ? location.ancla : 0
  );
  const refContenido = props.referenciaTabsContenido;
  const { tituloGeneral } = props;

  const settings = {
    focusOnSelect: true,
    infinite: false,
    slidesToShow: showSlider[0],
    slidesToScroll: 1,
    speed: 500,
    initialSlide: activeItem,
    dots: false,
    variableWidth: true,
  };

  const contextValue = useContext(GlobalContext);

  useEffect(() => {
    if (window.location.search) {
      setActiveItem(+window.location.search.split("sections")[1]);
      let el: any = document.getElementById("sections0");
      window.scrollTo({
        top: el.offsetTop,
        behavior: "smooth",
      });
    }
  }, []);
  return (
    <LayoutContext.Consumer>
      {(data) => (
        <div
          className={`m-tabs-sec ${
            props.nombreCategoria === "Interna empresas" ? "enterprises" : ""
          }`}
        >
          <div className="container-tabs">
            <h2 className="m-tabs-sec__title title-secondary">
              {tituloGeneral}
            </h2>
            <div className="m-tabs-sec__cont">
              <div className="m-tabs-sec__tabs scroll1 hide-on-mobile">
                <ul>
                  {refContenido &&
                    refContenido.map((tab, i) => (
                      <li key={`tab${i}`} className={``}>
                        <button
                          className={`m-tabs-sec__tabs-btn ${
                            activeItem === i
                              ? "m-tabs-sec__tabs-btn--active"
                              : ""
                          } gtmRedDeAmorConoceLosServiciosMenu${normalizeTwoWords(
                            tab.nombreTab
                          )}`}
                          onClick={() => {
                            setActiveItem(i);
                            data.slideServices?.set(i + 1);
                          }}
                        >
                          {tab.nombreTab}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
              <div className="show-on-mobile">
                <div className="m-tabs-sec__tabs ">
                  <Slider {...settings}>
                    {refContenido &&
                      refContenido.map((tab, i) => (
                        <div
                          className={`m-tabs-sec__tabs__mobile__internal `}
                          key={"m" + i}
                        >
                          <div>
                            <button
                              className={`m-tabs-sec__tabs-btn ${
                                activeItem === i
                                  ? "m-tabs-sec__tabs-btn--active"
                                  : ""
                              } gtmRedDeAmorConoceLosServiciosMenu${normalizeTwoWords(
                                tab.nombreTab
                              )}`}
                              onClick={() => {
                                setActiveItem(i);
                                () => data.slideServices?.set(i + 1);
                              }}
                            >
                              {tab.nombreTab}
                            </button>
                          </div>
                        </div>
                      ))}
                  </Slider>
                </div>
              </div>
              <div className="m-tabs-sec__details">
                <div className="m-tabs-sec__details-info">
                  <p className="m-tabs-sec__details-title">
                    {
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .tituloPrincipal
                    }
                  </p>
                  <div className="m-tabs-sec__details-desc">
                    <p>
                      {JSON.parse(
                        refContenido[activeItem].referenciaCursosDestacados[0]
                          .descripcion.raw
                      ).content[0].content[0].value
                        ? JSON.parse(
                            refContenido[activeItem]
                              .referenciaCursosDestacados[0].descripcion.raw
                          )?.content[0].content[0].value
                        : ""}
                    </p>
                  </div>
                  {props.nombreCategoria === "Servicios" ? (
                    <div className="m-tabs-sec__details-desc-virtuality">
                      <p>
                        {refContenido[activeItem]?.referenciaCursosDestacados[0]
                          ?.descripcionEvento &&
                          JSON.parse(
                            refContenido[activeItem]
                              ?.referenciaCursosDestacados[0]?.descripcionEvento
                              .raw
                          )?.content[0]?.content[0]?.value}
                      </p>
                    </div>
                  ) : null}
                  <Button
                    text={
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .textoBoton
                    }
                    classname={"a-button  secondary"}
                    type={
                      props.nombreCategoria === "Interna empresas"
                        ? "link"
                        : "button"
                    }
                    isDisabled={false}
                    strictCss={false}
                    gtmMark={"GTMnohay"}
                    href={
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .redireccionBoton
                    }
                    onClickAction={() => {
                      //console.log(refContenido[activeItem].referenciaCursosDestacados[0].nombreModerador)
                      if (
                        refContenido[activeItem].referenciaCursosDestacados[0]
                          .nombreModerador
                      ) {
                        localStorage.setItem(
                          "selected-service-id",
                          refContenido[activeItem].referenciaCursosDestacados[0]
                            .nombreModerador
                        );
                      }
                      refContenido[activeItem].nombreTab ===
                      "Hábitos para la salud mental"
                        ? navigate("/servicios/habitos-salud/")
                        : refContenido[activeItem].nombreTab ===
                          "Grupos de apoyo"
                        ? navigate("/servicios/grupos-de-apoyo")
                        : refContenido[activeItem].nombreTab ===
                          "Ruta de atención psicológica"
                        ? navigate("/servicios/ruta-atencion")
                        : contextValue.gigyaContext.gigyaAccount
                        ? navigate("/agenda-red-de-amor")
                        : contextValue.gigyaContext.login();
                    }}
                  />
                </div>
                <div className="m-tabs-sec__details-img hide-on-mobile">
                  <GatsbyImage
                    image={
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .imagenPrincipal &&
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .imagenPrincipal.gatsbyImageData
                    }
                    alt={
                      refContenido[activeItem].referenciaCursosDestacados[0]
                        .imagenPrincipal.title || "imagen tab"
                    }
                  />
                </div>

                {refContenido[activeItem].referenciaTarifas ? (
                  <FooterRatesTabs
                    tabsSectionRatesData={props}
                    activeItem={activeItem}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            {refContenido[activeItem].referenciaContenido ? (
              <SupportGroupFooter data={refContenido[activeItem]} />
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default TabsSection;
